/**
 * Matrix cell colour bands, most negative to most positive.
 * Mirrors backend/src/Submission/Colour.php — order is load-bearing.
 */
export enum Colour {
  Red = "red",
  Orange = "orange",
  Yellow = "yellow",
  Green = "green",
  Cyan = "cyan",
  Blue = "blue",
  Violet = "violet",
}

export type Cell = {
  readonly value: number
  readonly colour: Colour
}

/**
 * The 10×10 interference matrix as serialised by
 * backend/src/Submission/ResultMatrix.php.
 *
 * rowSums (topic-phase totals) and colSums (option-phase totals) are
 * keyed by phase strings (pluto…venus) in canonical order; cells align
 * positionally with that order on both axes.
 */
export type ResultMatrix = {
  readonly rowSums: Record<string, number>
  readonly colSums: Record<string, number>
  readonly cells: Cell[][]
}
